import { BROKER_LOGO } from "@/config/logos";

export const brokersList = [
  {
    id: "3",
    name: "Level2",
    disabled: false,
    note: <p></p>,
    logo: BROKER_LOGO["LEVEL2"].DARK.textLogo,
    icon: BROKER_LOGO["LEVEL2"].DARK.logo,
    type: "virtual",
    plan: "free",
    leverage: 1,
    maintainance: 1,
  },
  {
    id: "4",
    name: "Alpaca",
    note: null,
    logo: BROKER_LOGO["ALPACA"].DARK.textLogo,
    icon: BROKER_LOGO["ALPACA"].DARK.logo,
    defaultPassphrase: "s",
    type: "virtual",
    plan: "free",
    footerLink: "https://app.alpaca.markets/signup",
    leverage: 0.5,
    maintainance: 0.25,
    disabled: false,
    initialMarginHint:
      "Alpaca applies a minimum initial margin requirement of 50% for marginable securities and 100% for non-marginable securities.",
    maintainanceMarginHint:
      "FINRA has set the minimum maintenance requirement to at least 25% of the total market value.",
  },
  {
    id: "1",
    name: "Match Trade ",
    note: null,
    defaultApiSecret: "0",
    logo: BROKER_LOGO["MATCHTRADE"].DARK.textLogo,
    icon: BROKER_LOGO["MATCHTRADE"].DARK.logo,
    type: "virtual",
    plan: "pro",
    footerLink: "https://match-trader.com/",
    leverage: 0.01,
    maintainance: 0.01,
    disabled: false,
  },
  {
    id: "2",
    name: "Ctrader",
    note: null,
    disabled: false,
    logo: BROKER_LOGO["CTRADER"].DARK.textLogo,
    icon: BROKER_LOGO["CTRADER"].DARK.logo,
    defaultPassphrase: "live",
    type: "live",
    plan: "pro",
    footerLink: "https://ctrader.com/download",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "11",
    name: "Leverate",
    disabled: false,
    note: null,
    defaultPassphrase: "%20",
    logo: BROKER_LOGO["LEVERATE"].DARK.textLogo,
    icon: BROKER_LOGO["LEVERATE"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "14",
    name: "MetaTrader 5",
    note: null,
    logo: BROKER_LOGO["MT5"].DARK.textLogo,
    icon: BROKER_LOGO["MT5"].DARK.logo,
    type: "live",
    plan: "pro",
    footerLink: "https://www.metatrader5.com/",
    leverage: 0.01,
    maintainance: 0.01,
    disabled: false,
  },
  {
    id: "15",
    name: "FTMO Premium",
    note: null,
    logo: BROKER_LOGO["FTMO"].DARK.textLogo,
    icon: BROKER_LOGO["FTMO"].DARK.logo,
    type: "live",
    plan: "pro",
    footerLink: "https://www.metatrader5.com/",
    leverage: 0.01,
    maintainance: 0.01,
    disabled: false,
  },
  {
    id: "17",
    name: "Fennel",
    disabled: false,
    defaultPassphrase: "%20",
    note: null,
    logo: BROKER_LOGO["FENNEL"].DARK.textLogo,
    icon: BROKER_LOGO["FENNEL"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "29",
    name: "LAT",
    disabled: true,
    defaultPassphrase: "%20",
    note: null,
    logo: BROKER_LOGO["LAT"].DARK.textLogo,
    icon: BROKER_LOGO["LAT"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "30",
    name: "IG",
    disabled: false,
    note: null,
    logo: BROKER_LOGO["IG"].DARK.textLogo,
    icon: BROKER_LOGO["IG"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 0.01,
    maintainance: 0.01,
  },
  {
    id: "20",
    name: "Webull",
    disabled: true,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: null,
    logo: BROKER_LOGO["WEBBULLS"].DARK.textLogo,
    icon: BROKER_LOGO["WEBBULLS"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 1,
    maintainance: 1,
  },

  {
    id: "19",
    name: "Public",
    disabled: true,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: null,
    logo: BROKER_LOGO["PUBLIC"].DARK.textLogo,
    icon: BROKER_LOGO["PUBLIC"].DARK.logo,
    type: "live",
    plan: "pro",
    leverage: 1,
    maintainance: 1,
  },
  {
    id: "5",
    name: "Trade Zero",
    disabled: true,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: null,
    logo: BROKER_LOGO["TRADEZERO"].DARK.textLogo,
    icon: BROKER_LOGO["TRADEZERO"].DARK.logo,
    type: "virtual",
    plan: "pro",
    leverage: 1,
    maintainance: 1,
  },
  {
    id: "18",
    name: "Trade Station",
    disabled: true,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: null,
    logo: BROKER_LOGO["TRADESTATION"].DARK.textLogo,
    icon: BROKER_LOGO["TRADESTATION"].DARK.logo,
    type: "virtual",
    plan: "pro",
    leverage: 1,
    maintainance: 1,
  },
  {
    id: "13",
    name: "Lightspeed",
    note: null,
    disabled: true,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    logo: BROKER_LOGO["LIGHTSPEED"].DARK.textLogo,
    icon: BROKER_LOGO["LIGHTSPEED"].DARK.logo,
    type: "live",
    plan: "elite",
    footerLink: "https://lightspeed.com/trading/api-trading/level2",
    leverage: 1,
    maintainance: 0.25,
    initialMarginHint:
      "Lightspeed has a minimum initial margin requirement of 100%. Upgrade to a Reg T account to borrow up to 50% of the total purchase price of a security.",
    maintainanceMarginHint:
      "FINRA has set the minimum maintenance requirement to at least 25% of the total market value.",
  },
  {
    id: "26",
    name: "Sterling",
    disabled: false,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: null,
    logo: BROKER_LOGO["STERLING"].DARK.textLogo,
    icon: BROKER_LOGO["STERLING"].DARK.logo,
    type: "live",
    plan: "elite",
    leverage: 1,
    maintainance: 1,
  },
  {
    id: "28",
    name: "Pepperstone",
    note: null,
    logo: BROKER_LOGO["PEPPERSTONE"].DARK.textLogo,
    icon: BROKER_LOGO["PEPPERSTONE"].DARK.logo,
    type: "live",
    plan: "pro",
    footerLink: "https://pepperstone.com/",
    leverage: 0.01,
    maintainance: 0.01,
    disabled: false,
  },
];

export const predictionMarketBrokersList = [
  {
    id: "27",
    name: "Kalshi",
    disabled: false,
    defaultPassphrase: "%20",
    logo:
      BROKER_LOGO["KALSHI"]?.DARK?.textLogo ||
      "/images/logos/kalshi/text-logo.svg",
    icon: BROKER_LOGO["KALSHI"]?.DARK?.logo || "/images/logos/kalshi/icon.svg",
    type: "live",
    plan: "free",
    footerLink: "https://kalshi.com/",
    leverage: 1.0,
    maintainance: 1.0,
    note: null,
  },
];

export const allBrokersList = [...brokersList, ...predictionMarketBrokersList];

export const brokerOptions = Object.fromEntries(
  allBrokersList.map((broker) => [
    broker.id,
    {
      id: Number(broker.id),
      value: Number(broker.id),
      label: broker.name.trim(),
      leverage: broker.leverage,
      maintainance: broker.maintainance,
      disabled: broker.disabled,
      initialMarginHint: (broker as any).initialMarginHint,
      maintainanceMarginHint: (broker as any).maintainanceMarginHint,
      type: broker.type,
    },
  ]),
);
